<template>
  <div class="advancedSearch-top">
    <el-button type="text" icon="el-icon-arrow-left" class="getBackClass" @click="getBackClick">返回上一级</el-button>
    <el-dropdown class="advancedSearch-to-del">
      <span class="el-dropdown-link" v-if="token">
        <div style="width: 20px;height: 20px;"><img :src="'http://yyqce.xn--9kq86ifvd.com/'+this.avatar" alt="" class="gerenStyle" /></div>
      </span>
      <el-dropdown-menu slot="dropdown" v-if="token">
        <el-dropdown-item>
          <div @click="gerenSet">修改名称</div>
        </el-dropdown-item>
        <el-dropdown-item>
          <div @click="passwordClick">修改密码</div>
        </el-dropdown-item>
        <el-dropdown-item>
          <div @click="quitClick">退出登录</div>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog title="修改个人昵称" :visible.sync="dialogVisible" width="30%" :before-close="handleClose" center>
      <div class="nichengSty">
        <span>修改昵称:</span>
        <input type="text" v-model="names" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleList">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getUserInfo } from "@/api/attentionApi";
import { tokenLogin } from "@/api/home";
import { personageName, personageData } from "@/api/personalCenter";
export default {
  name: "quitVue",
  data() {
    return {
      dialogVisible: false,
      names: "",
      token:localStorage.getItem("token"),
      avatar:''
    };
  },
  mounted() { 
    if(this.token){
      this.getUserInfo();
    }
  },
  methods: {
    async getUserInfo() {
      let res = await getUserInfo({});
      this.avatar = res.data.avatar;
      // localStorage.setItem("name", this.getAesString(res.data));
    },

    //getBackClick  返回上一级
    getBackClick() {
      this.$router.go(-1);
    },
    //跳转到密码修改页面
    passwordClick() {
      this.$router.push("/passwordSet");
    },
    dialogVisibleList() {
      personageName({ nickname: this.names }).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.dialogVisible = false;
          personageData({}).then((res) => {
            localStorage.setItem("name", this.getAesString(res.data));
          });
          let ct = setTimeout(() => {
            location.reload();
            clearTimeout(ct);
          }, 1000);
        } else {
          this.$message({
            message: "修改失败",
            type: "warning",
          });
          this.dialogVisible = false;
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
        })
        .catch(() => { });
    },
    //个人基本设置
    gerenSet() {
      this.dialogVisible = true;
    },
    //跳转到个人中心
    gerenClick() {
      if (this.$route.path == "/personalCenter") {
        return;
      } else {
        this.$router.push("/personalCenter");
      }
    },
    quitClick() {
      this.$confirm("此操作会退出登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          tokenLogin({}).then((res) => {
            if (res.code == 0) {
              localStorage.removeItem("token");
              localStorage.removeItem("name");
              localStorage.removeItem("dataList");
              this.$message({
                type: "success",
                message: "退出成功!",
              });
              this.$router.push("/");
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消退出",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.getBackClass {
  margin-left: 100px;
}

.nichengSty {
  span {
    font-size: 16px;
  }

  input {
    height: 20px;
    margin-left: 10px;
  }
}

.gerenStyle {
  width: 30px;
  height: 30px;
  margin-top: 5px;
  border-radius: 50%;
}

.advancedSearch-top {
  height: 40px;
  /* background: #ffffff; */
  border-radius: 0px 0px 0px 0px;

  .advancedSearch-to-del {
    float: right;
    cursor: pointer;
    width: 64px;
    height: 16px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #000000;
    line-height: 40px;
    text-align: right;
    font-style: normal;
    text-transform: none;
    margin-right: 50px;

    .el-dropdown-link {
      width: 20px;
      height: 20px;
    }
  }

  ::v-deep {
    .el-dialog__body {
      display: flex;
      justify-content: center;
    }
  }
}
</style>